import React from 'react';
import { Image, StyleSheet, Text, View } from './base_components';

const styles = StyleSheet.create({
  dialogScreen: {
    alignSelf: 'center',
    flex: 1,
    maxWidth: '40rem',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  topLine: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  logo: {
    marginBottom: '2rem',
    width: '25rem',
    height: '5rem',
    filter: 'var(--icon-black)',
  },
  circleView: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: 0,
    height: 0,
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'visible',
  },
  circles: {
    width: '50rem',
    height: '50rem',
    filter: 'var(--login-circle-color)',
    maskImage: 'radial-gradient(white, transparent)',
  },
  title: {
    color: 'var(--login-title-text)',
    fontSize: '3rem',
    fontWeight: '600',
  },
  subtitle: {
    marginTop: '1.5rem',
    color: 'var(--login-subtitle-text)',
    fontSize: '1.6rem',
    textAlign: 'center',
  },
});

const CIRCLES = require('../assets/img/circles.svg');
const LOGO = require('../assets/img/logo.png');

export default function DialogScreen(props) {
  return (
    <View style={styles.dialogScreen}>
      <View style={styles.topLine}>
        <View style={styles.circleView}>
          <Image style={styles.circles} source={CIRCLES} />
        </View>
        <Image style={styles.logo} source={LOGO} />
      </View>
      {props.title ? <Text style={styles.title}>{props.title}</Text> : null}
      {props.subtitle ? (
        <Text style={styles.subtitle}>{props.subtitle}</Text>
      ) : null}
      {props.children}
    </View>
  );
}
